import { create } from 'zustand'

type CaptionState = {
  caption: string
  setCaption: (caption: string) => void
}

/**
 * The current spoken line, mirrored as on-screen text so the game is
 * playable muted and perceivable by screen-reader users.
 */
export const useCaptionStore = create<CaptionState>((set) => ({
  caption: '',
  setCaption: (caption) => set({ caption }),
}))
